import React from "react";
import { Currency } from "../../../_app/types";
import { Stack } from "@mui/material";
import AutoStrategyInvestment from "./AutoStrategyInvestment";
import { Strategy, TimeFrame } from "../../../store/slices/strategySlice";
import Leverage from "../../../_components/Leverage/Leverage";

interface Props {
  strategy: Strategy;
  middlePrice: number;
  onChangeInvestment: (value: number) => void;
  onChangeLeverage: (value: number) => void;
  onChangeCurrency: (value: Currency) => void;
  onChangeStepsCount: (value: number) => void;
  timeTerm: "Short" | "Mid" | "Long";
  timeFrames: TimeFrame[];
}

const AutoStrategyInvestmentSettings = ({
  strategy,
  onChangeInvestment,
  onChangeLeverage,
  onChangeCurrency,
  onChangeStepsCount,
  middlePrice,
  timeTerm,
  timeFrames,
}: Props) => {
  
  return (
    <Stack spacing={1} sx={{ paddingTop: 2 }}>
      <AutoStrategyInvestment
        timeTerm={timeTerm}
        strategy={strategy}
        middlePrice={middlePrice}
        onChangeStepsCount={onChangeStepsCount}
        onChange={onChangeInvestment}
        onChangeCurrency={onChangeCurrency}
        timeFrames={timeFrames}
      />
      <Leverage value={strategy.leverage} onChange={onChangeLeverage} />
    </Stack>
  );
};

export default AutoStrategyInvestmentSettings;
